<script lang="ts">
  import { _ } from 'svelte-i18n';

  import mbdImpressum from '../../assets/Digitale Schadenmeldung für Reifen- und Komplettradgarantien von Mercedes-Benz - Impressum_Stand 11-2025.pdf';
  import mbdDatenschutz from '../../assets/Digitale Schadenmeldung für Reifen- und Komplettradgarantien von Mercedes-Benz - Datenschutz_Stand 11-2025.pdf';
  import mbdHaftungsauschluss from '../../assets/Digitale Schadenmeldung für Reifen- und Komplettradgarantien von Mercedes-Benz - Haftungsausschluss_Stand 11-2025.pdf';
  import mbdParticipation from '../../assets/MBD-Teilnahmebedingungen_final.pdf';
  import ContactUs from './contact-us.svelte';
  import ThankYouModal from './thank-you-modal.svelte';

  let showContactUs = false;
  let showThankyouMessage = false;

  // export let isAppActive = true;
  export let isStartingInFuture = false;
</script>

{#if showContactUs && !showThankyouMessage}
  <ContactUs bind:showContactUs bind:showThankyouMessage />
{:else if showThankyouMessage}
  <ThankYouModal bind:showContactUs bind:showThankyouMessage />
{/if}

<div class="bg-cubiq-light-blue py-3 sm:py-4">
  <div class="mx-auto max-w-7xl px-3 sm:px-6">
    <div
      class="flex flex-col items-center justify-center gap-2 text-center sm:flex-col sm:gap-3"
    >
      <div
        class="flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-center"
      >
        {#if !isStartingInFuture}
          <a
            href={mbdImpressum}
            target="_blank"
            rel="noopener noreferrer"
            class="text-xs text-cubiq-dark-blue-700 transition-colors duration-200 hover:text-cubiq-dark-blue sm:text-sm"
            data-umami-event="Download - Impressum">{$_('Impressum')}</a
          >

          <span class="hidden text-cubiq-dark-blue-700 sm:inline">•</span>

          <a
            href={mbdDatenschutz}
            target="_blank"
            rel="noopener noreferrer"
            class="text-xs text-cubiq-dark-blue-700 transition-colors duration-200 hover:text-cubiq-dark-blue sm:text-sm"
            data-umami-event="Download - Datenschutz">{$_('Datenschutz')}</a
          >

          <span class="hidden text-cubiq-dark-blue-700 sm:inline">•</span>

          <a
            href={mbdHaftungsauschluss}
            target="_blank"
            rel="noopener noreferrer"
            class="text-xs text-cubiq-dark-blue-700 transition-colors duration-200 hover:text-cubiq-dark-blue sm:text-sm"
            data-umami-event="Download - Haftungsauschluss"
            >{$_('Haftungsauschluss')}</a
          >

          <span class="hidden text-cubiq-dark-blue-700 sm:inline">•</span>

          <span
            class="text-xs text-cubiq-dark-blue-700 sm:text-sm opacity-70"
            title="Will be delivered soon"
          >
            {$_('Terms and Conditions')}
          </span>

        {/if}

        <span class="hidden text-cubiq-dark-blue-700 sm:inline">•</span>

        <button
          on:click={() => (showContactUs = true)}
          class="text-xs text-cubiq-dark-blue-700 transition-colors duration-200 hover:text-cubiq-dark-blue sm:text-sm"
          data-umami-event="Contact Us"
        >
          {$_('Contact Us')}
        </button>
      </div>
    </div>
  </div>
</div>
